<div class="privacy-policy">
  <div class="privacy-policy__wrapper">
    <div class="privacy-policy__header">
      <h1>Aviso de privacidad</h1>
      <span class="text-gray-green-500">
        Última actualización: 21 de noviembre del 2024
      </span>
    </div>

    <p class="text-paragraph text-gray-green-800">
      En <strong>Proquifa</strong>, respetamos tu privacidad y estamos comprometidos con la protección de tus datos personales. Este Aviso de
      Privacidad está diseñado para informarte sobre cómo recopilamos, utilizamos, almacenamos y protegemos tu información, de
      acuerdo con la <strong> Ley Federal de Protección de Datos Personales en Posesión de los Particulares</strong>(LFPDPPP).
    </p>

    <article class="privacy-policy__content">
      <div class="privacy-policy__content__item">
        <h4>1. Identidad y Domicilio del Responsable</h4>
        <p>
          <strong>Proquifa S.A. de C.V.,</strong> con domicilio en José María Morelos 164, Niño Jesús, Tlalpan, 14080 Ciudad de México, CDMX,  es
          responsable del tratamiento de tus datos personales conforme a este Aviso de Privacidad.
        </p>
      </div>

      <div class="privacy-policy__content__item">
        <h4>2. Datos Personales Recabados</h4>
        <p>Los datos personales que podemos recabar incluyen:</p>
        <ul>
          <li><p>Nombre completo</p></li>
          <li><p>Dirección de correo electrónico</p></li>
          <li><p>Número de teléfono</p></li>
          <li><p>Dirección de envío y facturación</p></li>
          <li><p>Información de pago</p></li>
          <li><p>Datos relacionados con tus preferencias de compra y navegación</p></li>
        </ul>
      </div>

      <div class="privacy-policy__content__item">
        <h4>3. Finalidades del Tratamiento</h4>
        <p>La información personal que recabamos se utiliza para las siguientes finalidades:</p>
        <ul>
          <li><p>Procesar y gestionar tus pedidos.</p></li>
          <li><p>Proporcionar información sobre nuestros productos y servicios.</p></li>
          <li><p>Enviar promociones, ofertas o información relevante.</p></li>
          <li><p>Cumplir con obligaciones legales y fiscales.</p></li>
        </ul>
      </div>

      <div class="privacy-policy__content__item">
        <h4>4. Transferencias de Datos</h4>
        <p>Podemos compartir tus datos personales con:</p>
        <ul>
          <li><p>Proveedores de servicios necesarios para cumplir con los fines descritos (logística, sistemas de pago, etc.).</p></li>
          <li><p>Autoridades competentes en caso de requerimientos legales.</p></li>
        </ul>
        <p>No transferiremos tus datos personales a terceros sin tu consentimiento expreso, salvo en los casos previstos por la
        ley.</p>
      </div>

      <div class="privacy-policy__content__item">
        <h4>5. Derechos ARCO</h4>
        <p>Como titular de los datos personales, tienes derecho a:</p>
        <ul>
          <li><p>Acceder a tus datos personales.</p></li>
          <li><p>Rectificar información incorrecta o incompleta.</p></li>
          <li><p>Cancelar tus datos cuando consideres que no son necesarios para las finalidades descritas.</p></li>
          <li><p>Oponerte al uso de tus datos para fines específicos.</p></li>
        </ul>
        <p>Para ejercer estos derechos, puedes contactarnos en el correo electrónico: <a href="mailto:ventas@proquifa.com.mx" class="text-primary-500">ventas&#64;proquifa.com.mx</a> o en nuestro domicilio
        físico.</p>
      </div>

      <div class="privacy-policy__content__item">
        <h4>6. Seguridad de la Información</h4>
        <p>Implementamos medidas técnicas, administrativas y físicas para proteger tus datos personales contra acceso no
        autorizado, pérdida, alteración o uso indebido.</p>
      </div>

      <div class="privacy-policy__content__item">
        <h4>7. Cambios al Aviso de Privacidad</h4>
        <p>Este Aviso de Privacidad puede ser actualizado periódicamente para reflejar cambios en nuestras prácticas o en la
        legislación aplicable. Cualquier modificación será publicada en nuestro sitio web: <a href="https://www.proquifa.com.mx/" target="_blank" class="text-primary-500">https://www.proquifa.com.mx/</a></p>
      </div>

      <div class="privacy-policy__content__item">
        <h4>8. Contacto</h4>
        <p>Si tienes dudas, comentarios o inquietudes sobre este Aviso de Privacidad, puedes contactarnos en:</p>
        <ul>
          <li><p>Correo electrónico: <a href="mailto:ventas@proquifa.com.mx" class="text-primary-500">ventas&#64;proquifa.com.mx</a></p></li>
          <li><p>Teléfono: <a href="tel:+525513151498" class="text-primary-500">(55) 1315 1498</a></p></li>
        </ul>
      </div>
    </article>
  </div>
</div>
